<template>
  <div
    v-if="planStatus === 'trialing'"
    class="global__account-warning--small-text"
    :title="
      $t('message.trialPeriodTime.attention', { days: trialDays }) +
      ' ' +
      $t('message.trialPeriodTime.info')
    "
  >
    <trialing-message :trialDays="trialDays" /><span v-if="showCardWarnings"
      >&nbsp;</span
    >
  </div>
  <div v-else class="global__account-warning--small-text">
    <span v-html="userAlertError" v-if="userAlertError"></span
    ><span v-if="showCardWarnings">&nbsp;</span>
    <reactivate-account-message v-if="showReactivateAccountMessage" />
    <card-warnings :planStatus="planStatus" v-else-if="showCardWarnings" />
  </div>
</template>

<script>
import TrialingMessage from './TrialingMessage.vue'
import CardWarnings from './CardWarnings.vue'
import ReactivateAccountMessage from './ReactivateAccountMessage.vue'
import { mapState } from 'vuex'

export default {
  name: 'WarningMessage',
  components: {
    TrialingMessage,
    CardWarnings,
    ReactivateAccountMessage,
  },
  props: {
    planStatus: {
      required: true,
    },
    trialDays: {
      required: true,
    },
    userAlertError: {
      required: true,
    },
  },
  computed: {
    ...mapState('user', {
      userPlanInfo: (state) => state.userPlanInfo,
    }),
    showCardWarnings() {
      const userSubscription = this.userPlanInfo?.subscription
      return (
        Boolean(userSubscription) &&
        !this.userAlertError &&
        userSubscription.active !== true
      )
    },
    showReactivateAccountMessage() {
      return !this.userPlanInfo?.subscription
    },
  },
}
</script>
